import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
import styles from './image-search.scss';

const ImageSearch = () => {
  const formEl = useRef(null);
  const [uploading, setUploading] = useState(false);
  const url = `https://search.visenze.com/v1/product/search_by_image?app_key=bff0000f57f0c2d2b8d0c3a5474ef031&placement_id=501&limit=500&score=true&score_min=0.5`;

  const checkFileSize = file => {
    if (file && file.size && file.size < 10000000) {
      return true;
    }
    // eslint-disable-next-line no-alert
    window.alert(
      'Image too large, Make sure your image is not larger than 10mb.'
    );
    return false;
  };

  const postImageToViSense = async file => {
    const formData = new FormData();
    formData.append('image', file);
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Error uploading image : ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
      return { fetchError: error };
    }
  };

  const redirectToImageSearchPage = imId => {
    window.location.assign(`/image-search?imageId=${imId}`);
  };

  const checkIfImage = file => {
    const filetype = file?.type.substring(0, 6);
    if (filetype === 'image/') {
      return true;
    }
    // eslint-disable-next-line no-alert
    window.alert(
      'Unsupported image format, accepted formats are .jpg, .jpeg, .jpe, .png, .bmp, .dib, .webp, .pbm, .pmm, .sr, .ras, .tiff, .tif'
    );
    return false;
  };

  /* eslint-disable consistent-return */
  const uploadImage = e => {
    try {
      setUploading(true);
      const file = e.target.files[0];
      if (!file) {
        setUploading(false);
        // eslint-disable-next-line no-alert
        window.alert('Please select an image');
        return false;
      }

      if (checkFileSize(file) && checkIfImage(file)) {
        postImageToViSense(file)
          .then(data => {
            setUploading(false);
            if (data?.fetchError) {
              if (
                !/Load failed/.test(data.fetchError.message) &&
                !/Failed to fetch/.test(data.fetchError.message)
              ) {
                // eslint-disable-next-line no-alert
                window.alert('Error uploading the image, please try again');
              }
            } else if (data?.im_id) {
              redirectToImageSearchPage(data.im_id);
            } else {
              // eslint-disable-next-line no-alert
              window.alert(
                'Unable to correctly identify the image, please try again'
              );
            }
          })
          .catch(() => {
            setUploading(false);
            // eslint-disable-next-line no-alert
            window.alert('Error uploading the image, please try again');
          });
      }
    } catch (error) {
      setUploading(false);
      // eslint-disable-next-line no-alert
      window.alert('Something went wrong, There was a technical error.');
    }
  };

  const handleClick = () => {
    document.body.dispatchEvent(
      new CustomEvent('dataStateChange', {
        detail: {
          action: 'global.interaction',
          type: 'search',
          subType: 'image search cta',
          additionalInfo: {},
          properties: {},
          products: {},
        },
      })
    );
  };

  return (
    <form
      data-testid="search-image-container"
      className={classNames(styles.imageSearchContainer)}
      method="POST"
      action="/image-search"
      encType="multipart/form-data"
      ref={formEl}
    >
      <label
        className={classNames(styles.imageSearchLabel, {
          [styles.imageSearchLabel__uploading]: uploading,
        })}
      >
        <input
          type="file"
          id="image"
          name="image"
          accept="image/*"
          onChange={uploadImage}
          data-testid="image-search-input"
          onClick={handleClick}
        />
        {uploading ? (
          <LoadingSpinner />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            aria-labelledby="cameraTitle cameraDesc"
            role="img"
            className={styles.imageSearchLabel__pointer}
          >
            <title id="cameraTitle">Search by Image</title>
            <desc id="cameraDesc">
              This will allow you to search by a image or photo
            </desc>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 22C18.7614 22 21 19.7614 21 17C21 14.2386 18.7614 12 16 12C13.2386 12 11 14.2386 11 17C11 19.7614 13.2386 22 16 22ZM16 20C17.6569 20 19 18.6569 19 17C19 15.3431 17.6569 14 16 14C14.3431 14 13 15.3431 13 17C13 18.6569 14.3431 20 16 20Z"
              fill="#141414"
            />
            <path
              d="M23.6665 15.3333C24.2188 15.3333 24.6665 14.8856 24.6665 14.3333C24.6665 13.781 24.2188 13.3333 23.6665 13.3333C23.1142 13.3333 22.6665 13.781 22.6665 14.3333C22.6665 14.8856 23.1142 15.3333 23.6665 15.3333Z"
              fill="#141414"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 10H4V26.6667H28V10H24L22 6H10L8 10ZM11.2361 8L9.23607 12H6V24.6667H26V12H22.7639L20.7639 8H11.2361Z"
              fill="#141414"
            />
          </svg>
        )}
      </label>
    </form>
  );
};

export default ImageSearch;
